import { app_name, domainUrl } from '../config/Config';
const $ = window.$;
const jQuery = window.jQuery;
export const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
export const ratings = ['', '(Poor).', '(Below Average).', '(Average).', '(Above Average).', '(Good).', '(Excellent).', '(Outstanding).'];
export const toTimestamp = (strDate) => {
	var datum = Date.parse(strDate);
	return datum / 1000;
}
export const parseJwt = (token) => {
	if (token) {
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace('-', '+').replace('_', '/');
		return JSON.parse(window.atob(base64));
	} else {
		return false;
	}
}
export const isset = (strVariableName) => {
	if (typeof (strVariableName) == 'undefined' || strVariableName === null) {
		return false;
	}
	return true;
}
export const CKsettings = {
	toolbarGroups: [
		{
			name: 'clipboard',
			groups: ['clipboard', 'undo']
		},
		{
			name: 'links',
			groups: ['links']
		},
		'/',
		{
			name: 'basicstyles',
			groups: ['basicstyles', 'cleanup']
		},
		{
			name: 'paragraph',
			groups: ['list', 'indent', 'align', 'paragraph']
		},
		{
			name: 'styles',
			groups: ['styles']
		},
		{
			name: 'colors',
			groups: ['colors']
		}
	]
};
const $scrollbarleft3 = jQuery('#semana-scroll-left3');
export const range = (start, count) => {
	return Array.apply(0, Array(count)).map(function (element, index) {
		return index + start;
	});
}
export const ObserverEcoachMessage = (obj) => {
	let pamessage = "";
	if (getUserData("mentor", true)) {
		if (obj.evaluation_mentor == 1 && obj.evaluation_ecoach == 1 && obj.mentor_perform == 1 && obj.ecoach_perform == 1) {
			pamessage = "This component will be rated by your Observer(s) and E Coach. Please choose the Observer(s) from the list below.";
		}
		if (obj.evaluation_mentor == 1 && obj.evaluation_ecoach == 1 && obj.mentor_view == 1 && obj.ecoach_view == 1) {
			pamessage = "This component will be viewed by your Observer(s) and E Coach. Please choose the Observer(s) from the following list.";
		}
		if (obj.evaluation_mentor == 1 && obj.evaluation_ecoach == 0 && obj.mentor_perform == 1) {
			pamessage = " This component will be rated by your Observer(s). Please choose the Observer(s) from the following list.";
		}
		if (obj.evaluation_mentor == 1 && obj.evaluation_ecoach == 0 && obj.mentor_view == 1) {
			pamessage = "This component will be viewed by your Observer(s). Please choose the Observer(s) from the following list.";
		}
		if (obj.evaluation_mentor == 0 && obj.evaluation_ecoach == 1 && obj.ecoach_perform == 1) {
			pamessage = "This will be rated by your E Coach.";
		}
		if (obj.evaluation_mentor == 0 && obj.evaluation_ecoach == 1 && obj.ecoach_view == 1) {
			pamessage = "This will be viewed by your E Coach.";
		}
		if (obj.evaluation_mentor == 1 && obj.evaluation_ecoach == 1 && obj.mentor_perform == 0 && obj.ecoach_perform == 1 && obj.ecoach_view == 0 && obj.mentor_view == 1) {
			pamessage = "This will be rated by your E Coach and viewed by your Observer(s). Please choose the Observer(s) from the following list.";
		}
		if (obj.evaluation_mentor == 1 && obj.evaluation_ecoach == 1 && obj.mentor_perform == 1 && obj.ecoach_perform == 0 && obj.ecoach_view == 1 && obj.mentor_view == 0) {
			pamessage = "This component will be rated by your Observer(s) and viewed by your E Coach. Please choose Observer(s) from the following list.";
		}
	} else if (obj.evaluation_ecoach == 1) {
		pamessage = "This will be rated by your E Coach.";
	}
	return pamessage;
}
export const message = (title, message, type) => {
	//window.swal(title, message, type);
	
	if(type=='error')
	{
		window.swal(title, message, type);
	}
	else if(type=='library'){
		window.swal(title, message, '');
	}
	else
	{
		window.swal({
			text: message,
			animation: false,
		  })
	}
}
export const confirmmessage = (title, message, type) => {
	window.swal({
		//title: title,
		text: message,
		//type: type,
		showCancelButton: true,
		confirmButtonColor: '#14a430',
		cancelButtonColor: '#0082c9',
		animation: false,
		confirmButtonText: 'Ok'
	}).then((result) => {
		if (result) {
			return 1;
		} else {
			return 0;
		}
	});
}
export const objToSlashString = (obj) => {
	const keyValuePairs = [];
	for (const key in obj) {
		keyValuePairs.push(encodeURIComponent(obj[key]));
	}
	return "/" + keyValuePairs.join('/');
}
export const objToQueryString = (obj) => {
	const keyValuePairs = [];
	for (const key in obj) {
		keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
	}
	return keyValuePairs.join('&');
}
export const showHide = (showEle, hideEle) => {
	$(showEle).show();
	$(hideEle).hide();
}
export const reactLoader = (visible, text = "") => {
	if (visible == "show") {
		$('#overlay').show();
	} else if (visible == "hide") {
		$("#overlay").hide();
	}
	if (text != "") {
		$("#overlay #text").html(text);
	}
}
export const reactLoaderk = (visible, text = "") => {
	if (visible == "show") {
		$('#overlay1').show();
	} else if (visible == "hide") {
		$("#overlay1").hide();
	}
}
export const setTokenData = (key, val = "") => {
	localStorage.setItem("token" + app_name, val);
}
export const getTokenData = () => {
	if (localStorage.getItem("token" + app_name) != undefined) {
		return localStorage.getItem("token" + app_name);
	} else {
		return false;
	}
}
export const setUserData = (key, val = "", isUserData = false) => {
	if (isUserData) {
		// let sessData = localStorage.getItem("token"+app_name);
		//localStorage.setItem("token"+app_name, responseJson.token);
		if (getTokenData()) {
			// let userData = decode(getTokenData());
			// 	userData[key] = val;
			// 	return localStorage.setItem("token"+app_name, JSON.stringify(userData));
			return fetch(domainUrl + 'update-data', {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + getTokenData()
				},
				body: JSON.stringify({
					update: getTokenData(),
					key: key,
					val: val
				})
			}).then((response) => response.json()).then((responseJson) => {
				if (responseJson.status == 2) {
					localStorage.removeItem("token" + app_name);
					return localStorage.setItem("token" + app_name, responseJson.token);
					//return getTokenData();
				}
			});
		}
	}
	return localStorage.setItem(key + app_name, val);
}
export const getUserData = (key, isUserData = false) => {
	if (isUserData) {
		let tokenData = getTokenData();
		
		if (tokenData) {
			let userData = parseJwt(tokenData);
			// console.log(userData)
			return userData && userData[key] || false;
		}
	} else {
		return localStorage.getItem(key + app_name) || false;
	}
	// if (isUserData) {
	// 	let sessData = localStorage.getItem("user"+app_name);
	// 	return sessData && JSON.parse(sessData)[key] || false;
	// } else {
	// 	return localStorage.getItem(key+app_name) || false;
	// }
}
export const clearUserData = () => {
	// localStorage.removeItem("user"+app_name);
	// localStorage.removeItem("isLoggedIn"+app_name);
	// localStorage.removeItem("sessMax"+app_name);
	localStorage.clear();
	return true;
}
export const winResize = () => {
	jQuery(window).resize(function () {
		jsUpdateSize();
		let width = jQuery(window).width();
		let height = jQuery(window).height();
		fnscrollContent(height);
	});
}
export const jsUpdateSize = () => {
	var width = jQuery(window).width();
	var height = jQuery(window).height();
	jQuery("#contentsection").css({
		'border-left-width': '1px'
	});
	// Hide/Show Fullwidth Content Area
	if (width <= 1023) {
		jQuery('#contentsection').removeClass("halfcontent");
	} else {
		if (jQuery('#leftnavsec').is(':visible')) {
			jQuery('#leftnavsec').addClass("leftnavshow");
			jQuery('#leftnavsec').removeClass("leftnavhide");
			jQuery('#contentsection').css('width', '');
			jQuery('#contentsection').addClass("halfcontent");
			jQuery('#contentsection').css({
				'border-left-width': '1px'
			});
		} else {
			jQuery('#leftnavsec').removeClass("leftnavshow");
			jQuery('#contentsection').removeClass("halfcontent");
		}
	}
	// Hide/Show Fullwidth Content Area
	jQuery("#contentsection").css({
		'border-left-width': '1px'
	});
	// Mobile mmenu Starts
	if (width >= 768) {
		jQuery("html").removeClass("mm-opened mm-background mm-right mm-opening");
		jQuery("nav#menu").removeClass("mm-current mm-opened");
	}
}
export const composcroll = () => {
	if (jQuery('#semana-scroll').length > 0) {
		let $scrollbarContent = jQuery('#semana-scroll').tinyscrollbar();
		let scrollbarContent = $scrollbarContent.data("plugin_tinyscrollbar");
		scrollbarContent.update(0);
	}
}
export const fnRefreshDDAccordion = () => {
	/* $scrollbar5 = jQuery('#semana-scroll-inner');
	$scrollbar5.tinyscrollbar();
		*/
	$scrollbarleft3.tinyscrollbar();
	jQuery('#semana-scroll').tinyscrollbar();
	jQuery('#semana-scroll-left').tinyscrollbar();
	jQuery('#semana-scroll-left1').tinyscrollbar();
	jQuery('#semana-scroll-left2').tinyscrollbar();
	jQuery('#semana-scroll-mobile').tinyscrollbar();
	jQuery('#semana-scroll-mobile1').tinyscrollbar();
	jQuery('#semana-scroll-register').tinyscrollbar();
}
export const fnscrollContent = (arg) => {
	if ((arg > 700)) {
		jQuery('#semana-scroll-left .viewport').css({
			'height': (arg) - 326 + 'px'
		});
		jQuery('.contentarea').css({
			'min-height': (arg) - 180 + 'px'
		});
		jQuery('.left-nav').css({
			'min-height': (arg) - 160 + 'px'
		});
	} else {
		jQuery('#semana-scroll-inner .viewport', '#semana-scroll-left .viewport').css({
			'height': ''
		});
	}
	jQuery('#semana-scroll-left').tinyscrollbar();
}
export const updateScrollLeft = () => {
	let scrollbarleft3 = $scrollbarleft3.data("plugin_tinyscrollbar");
	if (scrollbarleft3) {
		scrollbarleft3.update("relative");
	}
}
export const showconleft = () => {
	jQuery("#contentsection").css({
		'border-left-width': '1px'
	});
	// Hide/Show Fullwidth Content Area
	jQuery('.showconleft').click(function () {
		let childLen = jQuery("div.silverheader").length;
		if (jQuery(window).width() <= 1023) {
			if (jQuery('#leftmenuarrow').hasClass('closearrow')) {
				jQuery("#menularge").show();
				jQuery("#menusmall").hide();
			} else {
				jQuery("#menusmall").show();
			}
			jQuery('#leftnavsec').toggle('slide', {
				direction: 'left'
			}, 800, function () {
				// Animation complete.
				/* if( jQuery('#leftmenuarrow').hasClass('closearrow') ) {
				 jQuery("#menusmall").show();
				}else{
				 //jQuery("#menusmall").show();
				} */
			});
			//Toggle Arrow
			if (jQuery('#leftmenuarrow').hasClass('closearrow')) {
				jQuery('#leftmenuarrow').addClass("openarrow");
				jQuery('#leftmenuarrow').removeClass("closearrow");
				//jQuery("#menusmall").hide();
				//jQuery("#menularge").show();
			} else {
				jQuery('#leftmenuarrow').addClass("closearrow");
				jQuery('#leftmenuarrow').removeClass("openarrow");
			}
			//Toggle Arrow
		} else {
			if (jQuery('#leftnavsec').is(':visible')) {
				if (childLen > 2) {
					jQuery("div.silverheader").eq(getVisibleMenuId() - 2).trigger("click");
				} else {
					jQuery("div.silverheader").eq(0).trigger("click");
				}

				jQuery('#leftmenuarrow').addClass("closearrow");
				jQuery('#leftmenuarrow').removeClass("openarrow");
				//jQuery('#leftnavsec').hide(900,'linear',function(){
				jQuery('#leftnavsec').toggle('slide', {
					direction: 'left'
				}, 800, function () {
					jQuery("#menusmall").show();
					jQuery("#menularge").hide();
					jQuery('#leftnavsec').addClass("leftnavhide");
					jQuery('#leftnavsec').removeClass("leftnavshow");
					jQuery('#contentsection').removeClass("halfcontent");
				});
				jQuery("#contentsection").animate({
					width: "92.2%"
				}, 600, function () {
					/*	var scrollbar5 = $scrollbar5.data("plugin_tinyscrollbar");
					 if(!scrollbar5){

					 }else{
					 scrollbar5.update("relative");
					 } */
				});
				jQuery('#contentsection').css({
					'border-left-width': '1px'
				});
				//Toggle Arrow
			} else {
				if (childLen > 2) {
					jQuery("div.silverheader").eq(getVisibleMenuId() + 2).trigger("click");
				} else {
					jQuery("div.silverheader").eq(1).trigger("click");
				}

				jQuery("#menusmall").hide();
				jQuery("#menularge").show();
				//jQuery('#leftnavsec').show(800);
				jQuery('#leftnavsec').toggle('slide', {
					direction: 'left'
				}, 650, function () { });
				jQuery("#contentsection").animate({
					width: "66%"
				}, 700, function () { });
				jQuery('#leftnavsec').addClass("leftnavshow");
				jQuery('#leftnavsec').removeClass("leftnavhide");
				//jQuery('#contentsection').css('width', '');
				jQuery('#contentsection').addClass("halfcontent");
				jQuery('#contentsection').css({
					'border-left-width': '1px'
				});
				/*	var scrollbar5 = $scrollbar5.data("plugin_tinyscrollbar");
				if(!scrollbar5){

				}else{
				 scrollbar5.update("relative");
				} */
				//Toggle Arrow
				jQuery('#leftmenuarrow').addClass("openarrow");
				jQuery('#leftmenuarrow').removeClass("closearrow");
			}
		}
	});
}
export const getVisibleMenuId = () => {
	let triggerChild = 0;
	jQuery("div.silverheader").map((key, obj) => {
		if ($(obj).next().is(':visible')) {
			triggerChild = key;
		}
	});

	return triggerChild;
}
export const headerLoad = () => {
	$(".landing-page header").sticky({
		topSpacing: 0
	});
	$('#mobNav').mmenu();
	jQuery('.others').click(function () {
		jQuery(".details").slideToggle(600);
	});
	$('body').on('click', function (evt) {
		if (evt.target.tagName !== 'LI' && evt.target.tagName !== 'IMG') {
			jQuery(".details").slideUp(600);
		}
	});
}
export const contentResizeLoad = () => {
	fnRefreshDDAccordion();
	var height = jQuery(window).height();
	fnscrollContent(height);
}
export const isAccordionInit = () => {
	return !jQuery.isEmptyObject(window.ddaccordion.headergroup);
}
export const ddaccordionInIt = (type = "") => {
	window.ddaccordion.init({
		headerclass: "silverheader", //Shared CSS class name of headers group
		contentclass: "submenu", //Shared CSS class name of contents group
		revealtype: "click", //Reveal content when user clicks or onmouseover the header? Valid value: "click", "clickgo", or "mouseover"
		mouseoverdelay: 200, //if revealtype="mouseover", set delay in milliseconds before header expands onMouseover
		collapseprev: true, //Collapse previous content (so only one open at any time)? true/false
		defaultexpanded: [0], //index of content(s) open by default [index1, index2, etc] [] denotes no content
		onemustopen: true, //Specify whether at least one header should be open always (so never all headers closed)
		animatedefault: false, //Should contents open by default be animated into view?
		persiststate: true, //persist state of opened contents within browser session?
		toggleclass: ["", "selected"], //Two CSS classes to be applied to the header when it's collapsed and expanded, respectively ["class1", "class2"]
		togglehtml: ["", "", ""], //Additional HTML added to the header when it's collapsed and expanded, respectively  ["position", "html1", "html2"] (see docs)
		animatespeed: "normal", //speed of animation: integer in milliseconds (ie: 200), or keywords "fast", "normal", or "slow"
		oninit: function (headers, expandedindices) { //custom code to run when headers have initalized
			if (type == 'big') {
				let triggerChild = (jQuery("div.silverheader").length > 2) ? 2 : 1;
				jQuery("div.silverheader").eq(triggerChild).trigger("click");
				if (jQuery('#lr3_scroll_dlr').length > 0) {
					jQuery('#lr3_scroll_dlr').tinyscrollbar();
				}
				if (jQuery("#lr2_scroll_guided").length > 0) {
					jQuery("#lr2_scroll_guided").tinyscrollbar();
				}
			} else {
				//jQuery("div.silverheader").eq(0).trigger( "click" );
			}
			//jQuery('#lr-wise-big').show();
			//jQuery("div.silverheader").eq(2).trigger( "click" );
			//jQuery("div.silverheader").eq(1).
			//do nothing
			//jQuery('#lr-wise-big').show();
			//jQuery('#lr-wise-small').show();
			//jQuery('#module-wise-small').hide();
			//jQuery('#module-wise-big').hide();
			jQuery('.lr-small').click(function () {
				if (jQuery('#lr-wise-small').is(':visible')) { } else {
					//jQuery('#module-wise-small').hide();
					//jQuery('#module-wise-big').hide();
					//jQuery('#lr-wise-big').show();
				}
			});
			jQuery('.module-small').click(function () {
				if (jQuery('#module-wise-small').is(':visible')) { } else {
					//jQuery('#lr-wise-small').hide();
					//jQuery('#lr-wise-big').hide();
					//jQuery('#module-wise-big').show();
				}
			});
			jQuery('.lr-big').click(function () {
				if (jQuery('#lr-wise-big').is(':visible')) { } else {
					//jQuery('#module-wise-big').hide();
					//jQuery('#module-wise-small').hide();
					//jQuery('#lr-wise-small').show();
				}
			});
			jQuery('.module-big').click(function () {
				if (jQuery('#module-wise-big').is(':visible')) {
					// jQuery('#module-wise-big').show();
				} else {
					//showing modulewise big here
					//jQuery("div.silverheader").eq(1).trigger( "click" );
					/* jQuery("div.silverheader").eq(0).removeClass('selected');
					jQuery("div.silverheader").eq(1).addClass('selected');
					// jQuery('#lr-wise-big').hide();
					jQuery('#lr-wise-small').hide();
					jQuery('#module-wise-small').show(); */
				}
			});
		},
		onopenclose: function (header, index, state, isuseractivated) { //custom code to run whenever a header is opened or closed
			//do nothing
			//closechecknot(index,state);
		}
	});
	jQuery('.accordion-item-1 .accordion-content').show();
	jQuery("#module-wise ul li").click(function () {
		if(jQuery(this).first().hasClass("active-accordion"))
		{
			jQuery(this).first().removeClass("active-accordion");
		}
		else
		{
			jQuery('#module-wise ul li').each(function () {
				jQuery(this).first().removeClass("active-accordion");
			});
			jQuery(this).first().addClass("active-accordion");
		}

		if (jQuery('#semana-scroll-left1').length > 0) {
			var $scrollbar = jQuery('#semana-scroll-left1');
			$scrollbar.tinyscrollbar();

			var scrollbarData = $scrollbar.data("plugin_tinyscrollbar");
			scrollbarData.update();
		}
		if (jQuery('#lr3_scroll_dlr').length > 0) {
			var $scrollbar = jQuery('#lr3_scroll_dlr');
			$scrollbar.tinyscrollbar();

			var scrollbarData = $scrollbar.data("plugin_tinyscrollbar");
			scrollbarData.update();
		}
	});
}
export const showLargeLeftMenu = () => {
	let childLen = jQuery("div.silverheader").length;
	if (childLen > 2) {
		jQuery("div.silverheader").eq(getVisibleMenuId() + 2).trigger("click");
	} else {
		jQuery("div.silverheader").eq(1).trigger("click");
	}
	jQuery('#leftnavsec').show();
	jQuery('#leftmenuarrow').addClass("openarrow");
	jQuery('#leftmenuarrow').removeClass("closearrow");
	jQuery("#menularge").show();
	jQuery("#menusmall").hide();
}
export const showSmallLeftMenu = () => {
	let childLen = jQuery("div.silverheader").length;
	if (childLen > 2) {
		let count = getVisibleMenuId() - 2;
		if (count >= 0) {
			jQuery("div.silverheader").eq(count).trigger("click");
		}
	} else {
		jQuery("div.silverheader").eq(0).trigger("click");
	}
	jQuery('#leftnavsec').hide();
	jQuery("#menularge").hide();
	jQuery("#menusmall").show();
	jQuery('#leftnavsec').addClass("leftnavhide");
	jQuery('#leftnavsec').removeClass("leftnavshow");
	jQuery('#contentsection').removeClass("halfcontent");
	jQuery("#contentsection").animate({
		width: "92.2%"
	}, 600, function () {
		/*	var scrollbar5 = $scrollbar5.data("plugin_tinyscrollbar");
		 if(!scrollbar5){

		 }else{
		 scrollbar5.update("relative");
		 } */
		jQuery('#contentsection').css({
			'border-left-width': '1px'
		});
		//jQuery("div.silverheader").eq(0).trigger( "click" );
		// jQuery('#module-wise-small').hide();
		// jQuery('#module-wise-big').hide();
		// jQuery('#module-wise-small').hide();
	});
}
export const downTabClose = () => {
	jQuery('.tab-close').click();
}
export const leftClose = () => {
	$('#qlinks aside').each(function () {
		$(this).removeClass('opened');
	});
}
export const scrollToTop = () => {
	$('html, body').animate({
		scrollTop: 0
	}, 300);
}

export const hideleftbar = () => {
	var width = jQuery(window).width();
	if(width < 768){
		if (jQuery('#leftmenuarrow').hasClass('openarrow')) {
			$('#leftmenuarrow').click();
		}
	}
}


// WEBPACK FOOTER //
// ./src/helpers/Common.js